import lightGallery from 'lightgallery';
import lgVideo from 'lightgallery/plugins/video';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgVimeoThumbnail from 'lightgallery/plugins/vimeoThumbnail';

export function mediaSlider() {
    const $lgMediaSliders = document.querySelectorAll('.lg-inline-gallery-container');

    $lgMediaSliders?.forEach($slider => {
        const inlineGallery = lightGallery($slider, {
            licenseKey: '6DC0246E-654D-481E-B173-50E4208CBD85',
            plugins: [lgVideo, lgThumbnail, lgVimeoThumbnail],
            container: $slider,
            hash: false,
            closable: false,
            showMaximizeIcon: true,
            download: false,
            appendSubHtmlTo: '.lg-item',
            autoplayFirstVideo: false,
            gotoNextSlideOnVideoEnd: false
        });
    
        setTimeout(() => {
            inlineGallery.openGallery();
        }, 200);
    });

}